import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Queue } from 'api/types';
import { AddPoolState } from 'components/drawers/add-pool-drawer/add-pool-state/add-pool-state.service';
import { PoolNameErrorHandler } from 'components/drawers/add-pool-drawer/pool-name-error-handler/pool-name-error-handler.class';
import { UTC_TIMES } from 'data/utc-times';
import { AddUTCToTimePipe } from 'pipes/add-utc-to-time.pipe';
import { TranslationKey } from 'pipes/translate.pipe';
import { SuppressErrorMatcher } from 'utils/error-matchers/suppress.error-matcher';
import { formatQueueDisplay } from 'utils/format-queue';
import { invalidCharactersValidator } from 'utils/validators/invalid-characters.validator';

@Component({
  selector: 'app-underutilization-edit-form',
  standalone: false,
  templateUrl: './underutilization-edit-form.component.html',
  styleUrl: './underutilization-edit-form.component.scss'
})
export class UnderutilizationEditFormComponent implements OnInit,OnChanges,AfterViewInit {
 @Input() public underutilizationedit:any
  @Output() getformStatus = new EventEmitter()
    checkformValidation:any
 fetchingdata:any;
underutilization!:FormGroup;
  @Output() public success = new EventEmitter<any>();
   @Output() public formdata = new EventEmitter<any>();
 public suppressErrorState = new SuppressErrorMatcher();
public getQueueDisplay = formatQueueDisplay;
constructor(public fb:FormBuilder,private addPoolState: AddPoolState,
  
  private addUTCToTimePipe: AddUTCToTimePipe){
     this.underutilization=this.fb.group({
     alertname:['',[Validators.required,invalidCharactersValidator]],
     Queue:['',Validators.required],
     Time:['',Validators.required],
     executive:['',Validators.required],
     Email:['',Validators.required]
    })
  }
  public utcStartTimes = [...UTC_TIMES];
 ngOnChanges(changes: SimpleChanges): void {
 
   if(this.underutilizationedit){
    
   
     this.underutilization.get('alertname')?.patchValue(this.underutilizationedit.alertName)
    //  this.underutilization.get('Queue')?.patchValue(this.underutilizationedit.queueName)
    // this.underutilization.get('Time')?.patchValue(this.underutilizationedit.alertSchedule)
    this.underutilization.get('executive')?.patchValue(this.underutilizationedit.runFrequency.runTime)
    this.underutilization.get('Email')?.patchValue(this.underutilizationedit.threshold.email)
    this.underutilization.get('Time')?.patchValue({'alertschdule':this.underutilizationedit.alertSchedule,
      'daystocheck':this.underutilizationedit.daysToCheck,'isPerDay': this.underutilizationedit.isPerDay,'isHourly':this.underutilizationedit.isHourly
    ,'percentage': this.underutilizationedit.threshold.percentage})


   }
 }

ngOnInit(): void {
   this.getformStatus.emit(false)
}

ngAfterViewInit(){
   this.fetchingdata= this.getQueueName(this.underutilizationedit.queueId)
   this.underutilization.get('Queue')?.patchValue(this.fetchingdata)
    this.underutilization.valueChanges.subscribe((ele:any)=>{
      if(this.underutilization.valid){
        this.success.emit(this.underutilization.value)
      }
      else{
          this.success.emit(null)
      }
      
    }) 


      
this.checkformValidation=this.underutilization.getRawValue();
    this.underutilization.valueChanges.subscribe((ele: any) => {
        if (JSON.stringify(this.checkformValidation) !== JSON.stringify(this.underutilization.getRawValue())) {
          this.getformStatus.emit(true);
        }else {
          this.getformStatus.emit(false);  
        }
    })
    
    if(this.underutilization.valid){
        this.success.emit(this.underutilization.value)
      }   
}

 public addUTCToTime(time: string): string {
    return this.addUTCToTimePipe.transform(time);
  }

  public get queues(): Queue[] {
    return this.addPoolState.queues;
  }

   getQueueName(Queueid:any){
    let temp=this.addPoolState.queues.filter((ele:any)=>{
       if(ele.id == Queueid){
           return ele?.name;
       }
    })
    return temp[0];
  }

   public get poolNameErrorMatcher(): PoolNameErrorHandler {
        return this.addPoolState.poolNameErrorHandler;
      }
    
      public poolNameErrorMessageKey(): TranslationKey {
        return 'error.invalidCharacter';
      }
}
